<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <maps :markers="marker" />
  </b-modal>
</template>

<script>
import MapTemplate from "../AppMapView";
export default {
  props: {
    marker: {
      type: Array,
      default: function () {
        return [];
      },
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close: function() {
      this.$emit("input", false);
      return;
    }
  },

  components: {
    maps: MapTemplate
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/Map.vue